export default {
	info(message) {
		/*Logs a message to the console, but only if the log level is set to a level that is high enough (3).
		 This prevents excessive logging as this is just an info message.*/
		if (this.$settings.logToConsole > 3) {
			console.log(message);
		}
	},

	notice(message) {
		/*Logs a message to the console, but only if the log level is set to a level that is high enough (2).
		 This prevents excessive logging as this is just a notice.*/
		if (this.$settings.logToConsole > 2) {
			console.log(message);
		}
	},

	error(message) {
		if (typeof message === "object") {
			//If the message is an object, it is converted into a string
			message = JSON.stringify(message);
		}
		if (this.$settings.alertErrors) {
			//If alert errors is switched on, it displays an alert with the message
			alert(message);
		}
		if (this.$settings.logToConsole > 1) {
			//If the log level is greater than 1, the message is passed into the console.
			console.error(message);
		}
	},

	fatal(message) {
		/*Checks the settings for the log to console level, if it is greater than 0
		(presumably this is always the case) it logs the message into the console */
		if (this.$settings.logToConsole > 0) {
			console.error(message);
		}
	},
};
